import './RegStyle.css';
import RegEngine from './RegEngine';
import Footer from '../Footer';
import Header from '../Header';

function RegPubb(props) {

	return (
		<>
			<Header />
			<div className="iol-lrcp-wrapper row reg-row adjustMargin">
				<div className="iol-lrcp-text-wrapper col-xl-6">
					<h1 className="large-title fucsia-text">Crea un account</h1><p className="heading-5">Scopri il servizio in prova gratuita per gestire una campagna pubblicitaria in piena autonomia.</p>
				</div>
				<RegEngine />
			</div>
			<Footer pageTitle="Registrazione Campagna"/>
		</>
	);
}

export default RegPubb;
